export const validateHistoricProductDataViewDate = (date: Date): boolean => {
	if (date.getTime() > new Date().getTime()) {
		return false;
	}

	const yearAgo = new Date();
	yearAgo.setDate(yearAgo.getDate() - 365 * 10);

	return date.getTime() > yearAgo.getTime();
};
